import { CrewDateBox } from 'components/devextreme/crewDateBox'
import { CrewSelectBox } from 'components/devextreme/crewSelectBox'
import { ValueChangedEvent as SelectBoxValueChangedEvent } from 'devextreme/ui/select_box'
import { ValueChangedEvent as DateBoxValueChangedEvent } from 'devextreme/ui/date_box'
import { useUserDataSource } from 'hooks/dataSource/useUserDataSource'
import { useCrewNavigate } from 'hooks/useCrewNavigate'
import qs from 'qs'
import { FC, memo, useCallback } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import dayjs from '@crew/modules/dayjs'
import { getParamAsString, isEqualParams } from 'utils'

import _ from 'lodash'
import { DatePickerDateFormat } from 'enums/system'
import { useTranslation } from '@crew/modules/i18n'

// AIクレジット利用履歴の検索コンポーネント

// 値変更毎にnavigateでクエリパラメータを更新する
// 再度上から処理が走り、クエリパラメータを元にフォームの値をセットすることで、URLとUIを同期させる
export const AiCreditUsageHistorySearch: FC = memo(() => {
  const { t } = useTranslation()

  const [searchParams] = useSearchParams()

  const { navigate } = useCrewNavigate()

  // 利用者 に表示するユーザーデータソース
  const userDataSource = useUserDataSource()

  // クエリパラメータからフォームの初期値を取得
  const fromDate = getParamAsString(
    'usageDateFrom',
    qs.parse(searchParams.toString())
  )

  const toDate = getParamAsString(
    'usageDateTo',
    qs.parse(searchParams.toString())
  )

  const selectedUserId = getParamAsString(
    'userId',
    qs.parse(searchParams.toString())
  )

  const location = useLocation()

  // 利用日Fromのイベントハンドラー
  const handleFromDateChanged = useCallback(
    (e: DateBoxValueChangedEvent) => {
      if (_.isEqual(e.value, e.previousValue)) return

      const currentParams: any = qs.parse(searchParams.toString())
      // nullや空文字はundefinedに置き換える
      const newParams = {
        ...currentParams,
        usageDateFrom: e.value
          ? `${dayjs(e.value).format('YYYY-MM-DD')}`
          : undefined,
        pageIndex: 0,
      }

      if (isEqualParams(currentParams, newParams)) return

      navigate(location.pathname, newParams)
    },
    [location.pathname, navigate, searchParams]
  )

  // 利用Toのイベントハンドラー
  const handleToDateChanged = useCallback(
    (e: DateBoxValueChangedEvent) => {
      if (_.isEqual(e.value, e.previousValue)) return

      const currentParams: any = qs.parse(searchParams.toString())
      // nullや空文字はundefinedに置き換える
      const newParams = {
        ...currentParams,
        usageDateTo: e.value
          ? `${dayjs(e.value).format('YYYY-MM-DD')}`
          : undefined,
        pageIndex: 0,
      }

      if (isEqualParams(currentParams, newParams)) return

      navigate(location.pathname, newParams)
    },
    [location.pathname, navigate, searchParams]
  )

  // 利用者のイベントハンドラー
  const handleSelectUserChanged = useCallback(
    (e: SelectBoxValueChangedEvent) => {
      if (_.isEqual(e.value, e.previousValue)) return

      const currentParams: any = qs.parse(searchParams.toString())
      // nullや空文字はundefinedに置き換える
      const newParams = {
        ...currentParams,
        userId: e.value || undefined,
        pageIndex: 0,
      }

      if (isEqualParams(currentParams, newParams)) return

      navigate(location.pathname, newParams)
    },
    [location.pathname, navigate, searchParams]
  )

  return (
    <div className="flex justify-between items-center">
      <div className="flex flex-row gap-x-2.5">
        {/* 利用日 */}
        <div className="flex gap-1 items-center px-2 py-1 rounded-lg crew-bg-gray-1">
          <label className="pr-1">{t('label.usageDate')}</label>
          {/* 利用日From */}
          <CrewDateBox
            type="date"
            defaultValue={fromDate}
            displayFormat={DatePickerDateFormat.YYYYMMDD}
            onValueChanged={handleFromDateChanged}
            showClearButton={true}
          />
          {'～'}
          {/* 利用日To*/}
          <CrewDateBox
            type="date"
            defaultValue={toDate}
            displayFormat={DatePickerDateFormat.YYYYMMDD}
            onValueChanged={handleToDateChanged}
            showClearButton={true}
          />
        </div>
        <div className="flex gap-1 items-center px-2 py-1 rounded-lg crew-bg-gray-1">
          <label className="pr-1">{t('label.usedBy')}</label>
          {/* 利用者 */}
          <CrewSelectBox
            displayExpr="displayName"
            valueExpr="id"
            defaultValue={selectedUserId}
            dataSource={userDataSource}
            minSearchLength={0}
            showClearButton={true}
            onValueChanged={handleSelectUserChanged}
            searchEnabled={true}
            searchExpr="displayName"
          />
        </div>
      </div>
    </div>
  )
})
